import React, { FC, useState, useEffect } from 'react'
import { motion, useMotionValueEvent, useScroll } from 'framer-motion';
import CALL from '../../../app/assets/images/phone-fill.svg';
import EMAILWHITE from '../../../app/assets/images/FooterLogos/mail-fill.svg'

interface FooterContactInfoProps {
    homePageData: any
}

const FooterContactInfo: FC<FooterContactInfoProps> = ({ homePageData }) => {
    const { scrollYProgress } = useScroll();
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useMotionValueEvent(scrollYProgress, 'change', (latest) => {
    })

    return (
        <div className='relative'>
            <div className='flex items-center justify-center w-full absolute z-10 -bottom-16'>
                <motion.div
                    style={{
                        scaleX: scrollYProgress,
                        x: '0%',
                        y: '0%'
                    }}
                    data-aos="fade-up"
                    className={`flex ${isMobile ? 'flex-col' : 'flex-row'} items-center justify-between gap-6 ${isMobile ? 'w-[95%] px-6 py-6' : 'w-9/12 px-12 pr-12 p-8'} rounded-2xl bg-[#313131] z-10`}
                >
                    <div className={`flex items-center justify-start gap-3 ${isMobile ? 'w-full' : 'w-3/6'} cursor-pointer`} onClick={() => { window.open(`https://mail.google.com/mail/?view=cm&fs=1&to=${homePageData.company_email}`) }}>
                        <div className={`bg-pink p-${isMobile ? '4' : '8'} rounded-full flex items-center justify-center ${isMobile ? 'w-10 h-10' : 'w-14 h-14'} relative`}>
                            <img src={EMAILWHITE} className={`${isMobile ? 'w-5 h-5' : 'w-6 h-6'} absolute`} alt="Email" />
                        </div>
                        <div className={`font-medium ${isMobile ? 'text-sm' : 'text-base'} truncate`}>{homePageData.company_email}</div>
                    </div>
                    <div className={`flex items-center justify-start gap-3 ${isMobile ? 'w-full' : 'w-3/6'} ${isMobile ? '' : 'border-l-4 border-[#E1E1E110] pl-10'} cursor-pointer`} onClick={() => { window.open(`tel:${homePageData.company_number}`) }}>
                        <div className={`bg-[var(--color-ternary)] p-${isMobile ? '4' : '8'} rounded-full flex items-center justify-center ${isMobile ? 'w-10 h-10' : 'w-14 h-14'} relative`}>
                            <img src={CALL} className={`${isMobile ? 'w-5 h-5' : 'w-6 h-6'} absolute`} alt="Call" />
                        </div>
                        <div className={`font-medium ${isMobile ? 'text-sm' : 'text-base'}`}>{homePageData.company_number}</div>
                    </div>
                </motion.div>
            </div>
        </div>
    )
}

export default FooterContactInfo
